import axios from '../shared/axios';

export function getFolderItems(assetID, contractorCompanyID) {
    return axios.get(`/api/Sharepoint/GetFolderItems?assetID=${assetID}&contractorCompanyID=${contractorCompanyID}`);
}
